import { readHiddenIds, HIDDEN_KEYS } from "./hiddenHistory";

/** Adjust DR/balance when sales are hidden locally (still in DB debit). */
export function computeCustomerDisplay(cust, allSales = []) {
  const hidden = new Set(readHiddenIds(HIDDEN_KEYS.sales));
  const custSales = allSales.filter(
    (sale) => String(sale.customer_id) === String(cust.id),
  );

  const hiddenSalesSum = custSales
    .filter((sale) => hidden.has(String(sale.id)))
    .reduce((sum, sale) => sum + Number(sale.total_amount ?? 0), 0);

  const storedDebit = Number(cust.debit ?? 0);
  const credit = Number(cust.credit ?? 0);
  const opening = Number(cust.opening_balance ?? 0);
  const debit = Math.max(0, storedDebit - hiddenSalesSum);
  const balance = opening + debit - credit;

  return {
    debit,
    credit,
    balance,
    opening,
    visibleSalesCount: custSales.filter(
      (sale) => !hidden.has(String(sale.id)),
    ).length,
  };
}
